// src/routes.js
import React from 'react';
import {Switch, Route, Redirect} from 'react-router-dom'

import Cerse from './Cerse';
import About from './About';
import Home from './Home';
import Thesis from './Thesis';

let Routes = (props) => {
    let isCerse = ((window.location||{}).href||'').includes('cerse.org');
    return (
      <Switch>
        <Route path="/about" component={About} />
        <Route path="/cerse" component={Cerse} />
        <Route path="/home" component={Home} />
        /* <Route path="/thesis" component={Thesis} /> */

        <Redirect from="/" to={isCerse ? "cerse" : "/home"}/>
      </Switch>
    );
}

export default Routes;



// WEBPACK FOOTER //
// ./src/components/routes.js